import { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { adminUpdateSettings } from '../actions/adminAction';
import styles from './AdminSettingsAddingPmErpForm.module.scss';
import { Checkbox } from '../../../UIPackage/MainModule/components/Checkbox';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { getAdminFetchSettings } from '../selectors/adminSelectors';

interface IAdminSettingsAddingPmErpForm {
  settings: IAdminSetting[];
}

const AdminSettingsAddingPmErpFormWithoutStore = ({ settings }: IAdminSettingsAddingPmErpForm) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isEnablePmForErp = settings?.find(setting => setting.code === AdminSettingCodesEnum.ENABLED_PM_FOR_ERP_4_1_19);

  const [isHideFields, setIsHideFields] = useState(isEnablePmForErp?.value === 'true');

  useEffect(() => {
    setIsHideFields(isEnablePmForErp?.value === 'true');
  }, [settings]);

  const onCheckboxChange = useCallback(() => {
    setIsHideFields(!isHideFields);
  }, [isHideFields]);

  const onSave = useCallback(() => {
    if (!isEnablePmForErp) return;
    dispatch(
      adminUpdateSettings(
        {
          ...isEnablePmForErp,
          value: isHideFields ? 'true' : 'false',
        },
        isEnablePmForErp.id,
      ),
    );
  }, [isHideFields]);

  return (
    <div className={styles.Wrapper}>
      <div className="shared-section-title">Добавление ПМ для ЕРП</div>
      <Checkbox
        id={'isHideFieldsCheckbox'}
        theme="system"
        onChange={onCheckboxChange}
        checked={isHideFields}
        label={'Включение профилактических мероприятий'}
        className={styles.CheckBox}
      />
      <Button color="primary" variant="contained" text="Сохранить изменения" onClick={onSave} />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IAdminSettingsAddingPmErpForm => ({
  settings: getAdminFetchSettings(state),
});

export const AdminSettingsAddingPmErpForm = connect(mapStateToProps)(AdminSettingsAddingPmErpFormWithoutStore);
